module.exports = __webpack_public_path__ + "static/img/qiye 03@2x.5d3341e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/qiye 03@2x.png
// module id = BCR+
// module chunks = 0